import { generatePath } from 'react-router';

/** Every path in one place — never hard-code a route string in a component. */
export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  CHANGE_PASSWORD: '/change-password',

  // Staff area
  DASHBOARD: '/dashboard',
  MEMBERS: '/members',
  MEMBER_DETAIL: '/members/:memberId',
  ENQUIRIES: '/enquiries',
  INVOICES: '/bills',
  ATTENDANCE: '/attendance',
  PACKAGES: '/packages',
  STAFF: '/staff',
  ROLES: '/roles',
  SETTINGS: '/settings',

  NOT_FOUND: '*',
} as const;

export type Route = (typeof ROUTES)[keyof typeof ROUTES];

/** Builders for routes that take parameters. */
export const buildRoute = {
  memberDetail: (memberId: number): string =>
    generatePath(ROUTES.MEMBER_DETAIL, { memberId: String(memberId) }),
  /** A path with list state in its query string, e.g. `/members?status=active`. */
  withQuery: (path: Route, query: Readonly<Record<string, string>>): string => {
    const search = new URLSearchParams(query).toString();
    return search ? `${path}?${search}` : path;
  },
};

/** Query-string keys the pages share, so a link from one page can drive another. */
export const SEARCH_PARAMS = {
  QUERY: 'q',
  STATUS: 'status',
  PAGE: 'page',
  VIEW: 'view',
  /** `?new=1` opens a page's "create" dialog — used by quick actions on the dashboard. */
  NEW: 'new',
  /** Unpaid / partly paid / paid, on the Bills screen. */
  PAYMENT_STATE: 'paymentState',
  /** The revenue period on the dashboard: a preset key, or `custom` with `from` and `to`. */
  PERIOD: 'period',
  FROM: 'from',
  TO: 'to',
  /** One calendar day, e.g. the Attendance screen's check-ins. */
  DAY: 'day',
} as const;
